import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Grid, Cell } from "react-md";
import SpecialAttentionNotes from "components/QualityAssurance/Sections/Outline/SpecialAttentionNotes";
import InspectionComments from "components/QualityAssurance/Sections/Outline/InspectionComments";
import QATouches from "components/QualityAssurance/Sections/Outline/QATouches";
import CaseReturns from "components/QualityAssurance/Sections/Outline/CaseReturns";
import OrderInformation from "components/QualityAssurance/Sections/CaseDetails/OrderInformation";
import Coverage from "components/QualityAssurance/Sections/CaseDetails/Coverage";
import SubjectAdress from "components/QualityAssurance/Sections/CaseDetails/SubjectAddress";
import { getGpsData } from "requests/qualityAssurance/index.ts";
import { caseHasForm } from "selectors/homeowner/caseForms/caseForms";
import CallLogs from "components/Homeowner/ContactEfforts/CallLogs.tsx";
import { getDetailedHistory } from "requests/homeowner/caseforms";
import { MCard } from "components/Shared";
import { QA_CASE_AUDIT_VIEW, QA_CASE_AUDIT_EDIT } from "typeConstants/rights";
import { userHasRight } from "selectors/rights";
import { QueueTypeEnum } from "interfaces/Mueller.Business.Models.ts";
import usePhoenixFormsSaveComplete from "components/PhoenixFormsV4/usePhoenixFormsSaveComplete.ts";

const Outline = (props) => {
  const mounted = useRef(true);
  const [gpsData, setGpsData] = useState({ needsFetch: true, geoCoords: { latitude: 0, longitude: 0 } });
  const [history, setHistory] = useState();

  useEffect(() => {
    // TODO: Move to redux as this is fetched both here and in CaseDetails
    if (gpsData.needsFetch) {
      fetchGpsData();
    }
    getDetailedHistory(controlNumber, setHistory, mounted);
    return () => mounted.current = false;
  }, []); 
  
  usePhoenixFormsSaveComplete(() => {    
    setGpsData({
      needsFetch : true,
      ...gpsData
    });
    fetchGpsData();
  });

  const fetchGpsData = () => {
    getGpsData(props.controlNumber, (s) => {
      setGpsData(s);
    }, mounted);
  };

  const {
    controlNumber,
    qaCase,
    qaCase: {
      caseInfo: {
        inspectionType,
        specialAttentionNotes,
        inspectionComments,
        qaTouches,
        caseReturns,
        customerNumber,
        customerName,
        policyNumber,
        policyholder,
        fieldRep,
        surveyAddress,
        atHomeStatus,
        surveyCounty,
        orderedDate,
        surveyDate,
        completedDate,
        trackingNumber,
        customerDueDate,
        caseType,
        governmentSponsorCode,
        primaryStatus,
        secondaryStatus,
        appraisalWorkflowStatus,
        transactionType,
        channel,
        stampsAndPhotoRequirementsLink,
        cubiCasaStatus,
      },
      controlIdNumber
    },
    displayAddressMap,
    canViewCoverageCard,
  } = props;

  let showCallLog = props.hasConvertForm || inspectionType === "CLOSE OUT";

  const filteredQaTouches = qaTouches?.filter(t => t.body?.length > 0);

  return (
    <Grid className="no-padding">
      {specialAttentionNotes && <Cell size={12}>
        <SpecialAttentionNotes text={specialAttentionNotes} />
      </Cell>}
      {caseReturns?.length > 0 && <Cell size={12}>
        <CaseReturns caseReturns={caseReturns} />
      </Cell>}
      {filteredQaTouches?.length > 0 && <Cell size={12}>
          <QATouches qaTouches={filteredQaTouches} />
        </Cell>}
      <Cell size={12}>
        <OrderInformation
          trackingNumber={trackingNumber}
          controlNumber={controlNumber}
          reportType={inspectionType}
          originalSurveyType={qaCase.caseInfo.originalInspectionType}
          orderedDate={orderedDate}
          surveyDate={surveyDate}
          completedDate={completedDate}
          customerDueDate={customerDueDate}
          caseType={caseType}
          policyOrLoanNumber={policyNumber}
          customerName={customerName}
          customerNumber={customerNumber}
          governmentSponsor={governmentSponsorCode}
          primaryStatus={primaryStatus}
          webStatus={secondaryStatus}
          assignmentType={transactionType}
          AppraisalStatus={appraisalWorkflowStatus}
          Channel={channel}
          stampsAndPhotoRequirementsLink={stampsAndPhotoRequirementsLink}
          cubiCasaStatus={cubiCasaStatus}
          atHomeStatus={atHomeStatus}
          policyholder={policyholder}
          fieldRep={fieldRep}
        />
      </Cell>
      <Cell size={12}>
        <SubjectAdress
          controlNumber={controlNumber}
          address={surveyAddress}
          county={surveyCounty}
          geocode={gpsData.geoCoords}
          onAddressClick={displayAddressMap}
        />
      </Cell>
      {canViewCoverageCard && <Cell size={12}>
        <Coverage controlNumber={controlIdNumber} />
      </Cell>}
      <Cell size={12}>
        <InspectionComments
          controlNumber={controlNumber}
          text={inspectionComments ? inspectionComments : ""}
          canUserEdit={true}
        />
      </Cell>
      {showCallLog && <Cell size={12}>
        <MCard title="Call Log">
          <CallLogs
            controlNumber={controlNumber}
            tableData={history?.callLogs}
          />
        </MCard>
      </Cell>}
      
      {/* 
      hiding this, because we will be bringing it back once we get Close Outs in summary view according to SD-23100
      hopefully this will help whoever has to do that task, as they will find this and just uncomment it
      <Cell size={12}>
        <ContactInformation
          controlNumber={controlNumber}
          policyholder={policyholder}
          fieldRep={fieldRep}
          agent={agent}
          caseType={caseType}
          borrower={policyholder}
          lenderDirector={lenderDirector}
          lenderManager={lenderManager}
          fieldSurveyCoordinator={fieldSurveyCoordinator}
          fieldSurveyDirector={fieldSurveyDirector}
          valuationCoordinator={valuationCoordinator}
          valuationDirector={valuationDirector}
          appraiser={appraiser}
        />
      </Cell> */}
    </Grid>
  );
};

Outline.propTypes = {
  controlNumber: PropTypes.number.isRequired,
  qaCase: PropTypes.object.isRequired,
  displayAddressMap: PropTypes.func,
  canViewCoverageCard: PropTypes.bool,
  hasConvertForm: PropTypes.bool,
  canViewAuditWarningCard: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    qaCase: state.qualityAssurance.qaCase,
    hasConvertForm: caseHasForm("MUELLER_CONVERT_PNX")(state),
    canViewAuditWarningCard: (userHasRight(QA_CASE_AUDIT_VIEW)(state) && state.qualityAssurance.qaCase?.caseAuditCompleted)
      || (userHasRight(QA_CASE_AUDIT_EDIT)(state) && state.qualityAssurance.qaCase?.qaQueueTypeId === QueueTypeEnum.AuditQa),    
  };
};

export default connect(mapStateToProps)(Outline);
